import { render, staticRenderFns } from "./audience-static-audience.vue?vue&type=template&id=17490f15&scoped=true&"
import script from "./audience-static-audience.vue?vue&type=script&lang=js&"
export * from "./audience-static-audience.vue?vue&type=script&lang=js&"
import style0 from "./audience-static-audience.vue?vue&type=style&index=0&id=17490f15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17490f15",
  null
  
)

export default component.exports